import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LogOut, ChevronLeft } from "lucide-react";
import { OrgStatusBanner } from "@/components/OrgStatusBanner";
import { NotificationCenter } from "@/components/NotificationCenter";
import { OfflineBanner } from "@/components/OfflineBanner";
import { useExitOnDoubleBack } from "@/lib/useExitOnDoubleBack";
import { useEffect } from "react";
import { prefetchPickups } from "@/lib/prefetchPickups";

export default function DriverLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const isHome = loc.pathname === "/driver";
  useExitOnDoubleBack(isHome);
  // Hors connexion : préchargement des documents à récupérer (au démarrage, au retour du réseau, toutes les 10 min) + coque de l'application en cache.
  useEffect(() => {
    if (!user?.id) return undefined;
    try { navigator.serviceWorker?.register("/sw.js"); } catch (_) {}
    const t0 = setTimeout(prefetchPickups, 1500);
    const t = setInterval(prefetchPickups, 600000);
    window.addEventListener("sanitdocs:resync", prefetchPickups);
    return () => { clearTimeout(t0); clearInterval(t); window.removeEventListener("sanitdocs:resync", prefetchPickups); };
  }, [user?.id]);

  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-background pb-8 relative">
      <header className="sticky top-0 z-20 bg-brand-800 text-white shadow-md shadow-brand-900/20">
        <div className="flex items-center justify-between px-4 h-14">
          {isHome ? (
            <Logo size={32} onDark />
          ) : (
            <button data-testid="driver-back" onClick={() => nav(-1)} className="flex items-center gap-1 text-white font-semibold -ml-1 active:scale-95 transition-transform">
              <ChevronLeft className="w-6 h-6" /> Retour
            </button>
          )}
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-brand-100">{user?.first_name}</span>
            <div className="[&_button[data-testid=notif-bell]]:bg-white/10 [&_button[data-testid=notif-bell]]:text-white [&_button[data-testid=notif-bell]]:w-9 [&_button[data-testid=notif-bell]]:h-9"><NotificationCenter role="chauffeur" /></div>
            <button data-testid="driver-logout" onClick={() => { logout(); nav("/login"); }} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white active:scale-95 transition-transform">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>
      <OrgStatusBanner />
      <OfflineBanner />
      <main className="px-4 pt-4 animate-fade-in">
        <Outlet />
      </main>
    </div>
  );
}
